var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('appointments-view',{attrs:{"active-tab":_vm.tab}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }